import { parseISO } from "date-fns";

const clean = (postalCode: string) =>
  postalCode.replace(/\s/g, "").toUpperCase();

export const validatePostalCode = (postalCode: string | undefined) => {
  if (!postalCode) return false;
  const isNumber = /^\d+$/.test(postalCode);
  const uniform = clean(postalCode);
  if (isNumber && uniform.length === 5) return true; // US style ZIP codes
  if (isNumber && uniform.length === 6) return true; // India style (PIN)
  if (!isNumber && /^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/.test(uniform))
    return true; // Canadian
  return false;
};

export const cleanPostalCode = (postalCode: string) => {
  const uniform = clean(postalCode);
  const isNumber = /^\d+$/.test(uniform);
  if (!isNumber && uniform.length === 6) {
    // e.g. M6J 0B8
    return `${uniform.substr(0, 3)} ${uniform.substr(3)}`;
  }
  // e.g. 90210, 111011
  return uniform;
};

export const validatePassword = (password: string) => {
  // N.B. length validation is done elsewhere
  // XXX: this is replicated on the backend, keep in sync
  // at least one letter and one number
  return /\d/.test(password) && /[A-Za-z]/.test(password);
};

/**
 * A pretty permissive phone number validator.
 */
export const validatePhoneNumber = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return false;
  const withoutNonsense = phoneNumber.replace(/[\s()-]/g, "");
  const isValid =
    /^(?!\b(0)\1+\b)(\+?\d{1,3}[. -]?)?\(?\d{3}\)?([. -]?)\d{3}\3\d{4}/.test(
      withoutNonsense
    );
  return isValid;
};

const OLDEST_ACCEPTABLE_DATE_MS = +new Date("1980-01-01");
const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;

export const validateInThePast = (isoDate: string) => {
  const instant = +parseISO(isoDate);
  const now = +new Date();
  const oldest = OLDEST_ACCEPTABLE_DATE_MS;
  return now > instant && instant > oldest;
};

export const getAge = (birthdate: Date) => {
  return Math.floor((+new Date() - +birthdate) / ONE_YEAR_MS);
};

export const displayCents = (cents: number, currencyCode?: string) => {
  const numericAmount = (cents / 100).toFixed(2);
  if (currencyCode?.toLowerCase() === "cad") return `$${numericAmount}`; // XXX: requested to remove C$, but could cause confusion
  if (!currencyCode) return numericAmount;
  return `${currencyCode.toUpperCase()} ${numericAmount}`;
};
